export default __webpack_public_path__ + "static/media/rack_stack_2.7d93f560.jpg";